import { classNames } from 'shared/lib/classNames/classNames';
import { useSelector } from 'react-redux';
import { getPlotStepData } from 'widgets/PlotSteps';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { Buttons } from '../Buttons';
import cls from './FinalScreen.module.scss';

interface FinalScreenProps {
    className?: string
}
export const FinalScreen = (props: FinalScreenProps) => {
    const {
        className,
    } = props;
    const stepData = useSelector(getPlotStepData);

    return (
        <div className={classNames(cls.FinalSum, {}, [className])}>
            <div className={cls.speaker}>
                <img className={cls.speakerImg} src={stepData?.action?.finalScreen?.speakerImg} alt="Персонаж" />
            </div>
            <div className={cls.congragTextBox}>
                <Title className={cls.title} color="#353850" size={TitleSize.title_50}>
                    {
                        stepData?.action?.buttons[0]?.linkOnStep !== 135 && <>
                            {'Ура!' }
                            <br/>
                        </>
                    }
                    {stepData?.action?.finalScreen?.text}
                </Title>
            </div>
            <div className={cls.forward}>
                <Buttons />
            </div>
        </div>
    );
};
